<template>
    <div class="pl-2 pr-2 pt-1">
        <p class="text-sm text-gray-600 font-medium w-auto pl-2 whitespace-wrap self-center">{{ text }}</p>
    </div>
</template>

<script>
export default {
	name: "lucide-icon",
	props:{
        text: {
            type: String,
            required: true
        },
    },
	data() {
		return {
        }
	},
	created(){
	},
	methods: {
	},
	computed: {
	},
	watch: {
	}
}
</script>